import React, { useState } from "react"
import Layout from "../../../components/layouts"
import Banner from "../../../components/features/Banner"
import SEO from "../../../components/common/SEO"
import ReactWOW from "react-wow"
import FeatureCards from "../../../components/features/FeatureCards"

export const query = graphql`
  query ContractorOrientations {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

export default ({ data }) => {
  const [toggler, setToggler] = useState(false)
  const lightboxProps = {
    toggler: toggler,
    setToggler: setToggler,
    sources: ["https://www.youtube.com/watch?v=xE2yXvWB038"],
  }

  const bannerProps = {
    title: "Contractor and Visitor Orientations",
    subtitle: `Your employees probably have a good handle on your policies, procedures, and protocols. They've probably also been made aware of any site-specific hazards and appropriate controls to mitigate those hazards. But what about your contractors? They're even less familiar with your surroundings. They need to know this stuff as much as anyone.`,
    featureName: "behaviourObservations",
    rightButtonText: "Why Certificate Tracking Software?",
    rightButtonSrc: "https://www.youtube.com/watch?v=xE2yXvWB038",
    mockupImg:
      "/features/contractor-orientations/feature-page-header-orientations.png",
  }

  const seo = {
    title: "Workhub | Free Contractor Orientation Software Onboarding Training",
    description:
      "Introduce & onboard newly inducted contractors to your jobsite by hosting a video in our Contractor Orientation Tool.",
    image: "/features/contractor-orientations/social-card.jpg",
    // pathname,
    // article
  }

  const featureIndex = [
    {
      title: "Site Orientation",
      para: "Build a site orientation that covers who to report to, procedures for reporting incidents and emergencies, site evacuation, muster points, prohibited areas, and any other site-specific protocols you may have.",
    },
    {
      title: "Hosting",
      para: "If you already have an orientation, they can be uploaded to Workhub for global access.  Our in-house content team also offer competitive pricing for creating orientation videos for your organization.",
    },
    {
      title: "Track Completion",
      para: "A record of completed orientations is available in your admin dashboard and is searchable by subcontractor company.",
    },
    {
      title: "Worker ID",
      para: "Look up whether individual workers have completed orientations by checking their WorkerID.",
    },
    {
      title: "History Lookups",
      para: "See who accessed a location to assist with incident investigations or to enable contact tracing. ",
    },
    
  ]

  console.log(featureIndex)

  return (
    <Layout {...lightboxProps}>
      <SEO {...seo} {...data.site} />
      <Banner {...bannerProps} {...lightboxProps} />

      <main className="feature-main">
        <section className="feature-section">
          <div className="container" style={{ maxWidth: "1200px" }}>
            <div className="row">
              {/* SECTION ONE */}
              <div className="col-lg-6 feature-text">
                <h2>What should be in a Site Orientation?</h2>
                <p style={{marginBottom: '0px'}}>
                  An orientation should cover all the basics of being on-site and working with your organization. It should cover:
                </p>

                <ol className="checklist">
                  <li>Who is in charge and who to go to with issues and concerns (and where they’re located)</li>
                  <li>Procedures for reporting hazards, incidents, and emergencies</li>
                  <li>Details on site evacuation and muster point location</li>
                  <li>Required PPE for being on-site</li>
                  <li>Prohibited areas</li>
                  <li>Unusual hazards</li>
                  <li>Site-specific protocols</li>
                </ol>

                <p>
                  Your site orientation might only take a few minutes and could be done by a gatekeeper, but that’s both time-consuming and hard to scale! A video hosted online is easier to access and available 24/7.
                </p>
              </div>

              <div className="col-lg-6 feature-img">
                <img
                  src="/features/contractor-orientations/orientations-cartoon.png"
                  className="feature-img-left"
                  alt="Admin Laptop"
                />
              </div>
            </div>
          </div>
        </section>

        {/* SECTION TWO */}

        <section className="feature-section">
          <div className="container" style={{ maxWidth: "1200px" }}>
            <div className="row switch-children">
              <div className="col-lg-6 feature-img">
                <img
                  src="/features/contractor-orientations/c-orientations-worker-1.png"
                  className="feature-img-right"
                  alt="Worker Tablet"
                />
              </div>

              <div className="col-lg-6 feature-text">
                <h2>Access company orientations or host your own</h2>
                <p>
                  Orientations are intended to help you onboard new workers and contractors from outside your organization, ensuring everyone’s up to speed and ready to be on-site first thing on Monday. 
                  Orientations within Workhub are video lessons or PDFs similar to Online Training courses with one major difference - Orientations aren’t limited to just your account, and are visible to 
                  other organizations.
                </p>
                <p>
                  If your business needs an orientation, Workhub is also happy to create one for you! We feel our work is top-notch and our rates are competitive, so please contact us if we 
                  can help create one for your organization. Regardless of where your orientation is sourced, safe worksites are our goal.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION THREE */}

        <section className="feature-section">
          <div className="container" style={{ maxWidth: "1200px" }}>
            <div className="row">
              <div className="col-lg-6">
                <h2>
                  All orientations in Workhub are globally visible and accessible for free
                </h2>
                <p>
                  Completion of orientations by your workers and contractors is visible on your admin dashboard, and the results are searchable by subcontractor company, allowing you simple and easy 
                  visibility of who is up-to-speed. Worker completions can also be tracked using WorkerID (another Workhub feature), allowing workers and contractors to have their proof of completion 
                  on them at all times - even offline!
                </p>
              </div>

              <div className="col-lg-6 feature-img">
                <img
                  src="/features/contractor-orientations/c-orientations-worker-3.png"
                  className="feature-img-left"
                  alt="Worker Mobile"
                />
              </div>
            </div>
          </div>
        </section>

        {/* FEATURE OVERVIEW */}

        <section className="feature-overview-container">
          <h2>Overview</h2>

          <div className="feature-overview-grid">
            {featureIndex.map(item => (
              <FeatureCards title={item.title} para={item.para} />
            ))}
          </div>
        </section>


      </main>
    </Layout>
  )
}
